import ItemModelV2 from "../../model2/item2/item-model"
import {EntityType} from "../../gd/const/item"

export type DndProps = {
    listItem            : ItemModelV2
    onHover?            : callback
    type?               : string
    // manager             : any   // hmmm - define by type = DNDProp & {custom props)
    canMoveTask?        : boolean
    canMoveProject?     : boolean
}

export type DndDraggedComponent = {
    props               : DndProps
}

export type DndDropResult = {

    // draggedComponent what we drop
    // targetComponent to where


    targetItemModel         : ItemModelV2
    targetParentItemModel?  : ItemModelV2
    type?                   : DraggedOverPosition

    isDropInto?             : boolean
    isReorder?              : boolean
    sortPosition?           : number //dropSortPosition
}

export enum DndType {
    TARGET = 'target',
    SOURCE = 'source',
    BOTH = 'both',
    DISABLED = 'disabled'
}

export enum DraggedOverPosition {
    TOP     = 'top',
    CENTER  = 'center',
    BOTTOM  = 'bottom'
}

export type DndOnHoverParams = {
    type            : EntityType | 'last-row'
    parent?         : ItemModelV2 // only if 'last-row' and parent = ItemModel (project)

    listItem?       : ItemModelV2
    draggedOver?    : DraggedOverPosition
}